import Heading from '/components/ui/typography/Heading';
import Paragraph from '/components/ui/typography/Paragraph';
import MaterialList from '../backend/MaterialList';
import useUserCan from '/hooks/useUserCan';
import { Material } from '/types/jobTemplateTypes';

interface Props {
    materials: Material[];
    onChange: (materials: Material[]) => void;
}

export default function JobMaterials({ materials, onChange }: Props) {
    const userCan = useUserCan();
    return (
        <>
            <Heading as="div" size="medium" className="mb-12">
                Materielliste
            </Heading>
            <Paragraph size="small" weight="weak" className="mb-24">
                Rediger materiellisten dersom endringer er nødvendig
            </Paragraph>
            <MaterialList
                materials={materials}
                onUpdate={onChange}
                className="mb-48"
                hidePrices={!userCan.seeMaterialListPrices}
                readOnly={!userCan.editTemplateJobMaterialList}
            />
        </>
    );
}
